import {jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import {MailOutlined} from '@mui/icons-material'
import useBreakpoint from '../../../../hooks/useBreakpoint'
import {Breakpoint} from '../../../../types/constEnums'
import ProviderRowActionButton from './ProviderRowActionButton'

const Form = styled('form')({
  display: 'flex',
  flex: 1
})






const ContactUsButton = (props) => {
  const {contactUsUrl, onContactUsSubmit} = props
  const isDesktop = useBreakpoint(Breakpoint.SIDEBAR_LEFT)

  return (
    _jsx(Form, { method: "get", target: "_blank", action: contactUsUrl, onSubmit: onContactUsSubmit, children: 
      _jsx(ProviderRowActionButton, { palette: "warm", children: 
        isDesktop ? 'Contact Us' : _jsx(MailOutlined, {} )
      }, "request")
    })
  )
}

export default ContactUsButton
